import { useRef, useState } from "react";
import { useSelector } from "react-redux";
import { Alert, Button, Paper, Typography } from "@mui/material";
import { PageTitle } from "../../../shared/ui/common";
import { startSandboxPayment } from "../api/sandbox";
import { paymentError } from "../api/payments";
import SandboxRefund from "./SandboxRefund";
import SandboxRefundStatus from "./SandboxRefundStatus";
import SandboxSecurity from "./SandboxSecurity";

/** Operator-only verification flow using existing authenticated payment endpoints. */
export default function PaymentSandbox() {
  const { token, userId } = useSelector((state) => state.user);
  const [payment, setPayment] = useState(null), [busy, setBusy] = useState(false), [error, setError] = useState("");
  const reference = useRef(null), pending = useRef(false);
  async function create() {
    if (pending.current || payment) return;
    pending.current = true; setBusy(true); setError("");
    try {
      reference.current ||= `sandbox-${crypto.randomUUID()}`;
      setPayment(await startSandboxPayment(token, Number(userId), reference.current));
    }
    catch (reason) { setError(reason.message.startsWith("sandbox-")
      ? "فقط با تنظیمات ذخیره‌شدهٔ فعال در محیط تست و کلید TEST می‌توان پرداخت آزمایشی ایجاد کرد. تنظیمات یا پاسخ درگاه را بررسی کنید."
      : paymentError(reason)); }
    finally { pending.current = false; setBusy(false); }
  }
  return <>
    <PageTitle title="آزمایش پرداخت درگاه" broadCrumb={[{ title: "تنظیمات درگاه", path: "/payment-gateway" }]} />
    <Paper variant="outlined" className="md:mx-3 mx-1 p-4">
      <Typography variant="h6" className="mb-4">آزمایش MultiSafepay Sandbox</Typography>
      <Alert severity="info" className="mb-4">این عملیات یک سفارش آزمایشی ۱ یورویی برای حساب واردشده می‌سازد. محیط اصلی پذیرفته نمی‌شود. برگشت مرورگر به‌تنهایی تأیید پرداخت نیست؛ نتیجه را در گزارش پرداخت‌ها بررسی کنید.</Alert>
      {error && <Alert severity="error" className="mb-4">{error}</Alert>}
      <Button type="button" variant="contained" disabled={busy || Boolean(payment)} onClick={create}>{busy ? "در حال ایجاد…" : "ایجاد پرداخت آزمایشی ۱ یورویی"}</Button>
      {payment && <div className="my-4">
        <p>شناسه سفارش: <span dir="ltr">{payment.id}</span></p>
        <p>مرجع آزمایش: <span dir="ltr">{payment.reference}</span></p>
        <Button component="a" href={payment.paymentUrl} target="_blank" rel="noopener noreferrer" variant="contained">رفتن به درگاه تست</Button>
      </div>}
      <div className="flex gap-3 mt-4"><Button component="a" href="/payment-gateway">تنظیمات درگاه</Button><Button component="a" href="/transaction">گزارش پرداخت‌ها</Button></div>
      <SandboxRefund />
      <SandboxRefundStatus />
      <SandboxSecurity />
    </Paper>
  </>;
}
